import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface CursorPointerIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const CursorPointerIcon = ({ className, ...props }: CursorPointerIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9_524)">
      <path
        clipRule="evenodd"
        d="M19.5027 9.96958C20.7073 10.4588 20.6154 12.1941 19.3658 12.5533L13.0605 14.3658L10.1807 20.2606C9.60996 21.4288 7.88499 21.218 7.6124 19.9468L4.67677 6.25646C4.44638 5.18204 5.5121 4.2878 6.53019 4.70126L19.5027 9.96958Z"
        fillRule="evenodd"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_9_524">
        <rect
          fill="white"
          height="24"
          width="24"
        />
      </clipPath>
    </defs>
  </svg>
);

export default CursorPointerIcon;
